
import { useState, useEffect } from 'react';
import { fanActivityService, FanActivityStats } from '@/services/fanActivityService';
import { useAuth } from './useAuth';
import { useInternalAuth } from './useInternalAuth';

export const useFanActivity = () => {
  const { user: supabaseUser } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const [stats, setStats] = useState<FanActivityStats>({ likes: 0, comments: 0, shares: 0, posts: 0 });
  const [loading, setLoading] = useState(false);

  const user = supabaseUser || internalUser;

  const loadFanActivity = async () => {
    if (!user?.id) return;
    
    setLoading(true);
    try {
      const activityStats = await fanActivityService.getFanActivityStats(user.id);
      setStats(activityStats);
    } catch (error) {
      console.error('Error loading fan activity:', error);
    } finally {
      setLoading(false);
    }
  };

  const recordLike = async (contentId: number) => {
    if (!user?.id) return;
    
    await fanActivityService.recordLike(user.id, contentId);
    await loadFanActivity(); // Refresh stats
  };

  const recordComment = async (contentId: number, commentText: string) => {
    if (!user?.id) return;
    
    await fanActivityService.recordComment(user.id, contentId, commentText);
    await loadFanActivity(); // Refresh stats
  };

  const recordShare = async (contentId: number) => {
    if (!user?.id) return;
    
    await fanActivityService.recordShare(user.id, contentId);
    await loadFanActivity(); // Refresh stats
  };

  useEffect(() => {
    loadFanActivity();
  }, [user?.id]);

  return {
    stats,
    loading,
    loadFanActivity,
    recordLike,
    recordComment,
    recordShare
  };
};
